import { format } from 'date-fns';
import type { User as FBUser, UserMetadata } from 'firebase/auth';

import { DateFormats } from 'constants/enums';
import type { User } from 'models/user.interface';

export const formatFbUser = (user?: FBUser | null) => {
  if (!user) {
    return null;
  }

  return {
    uid: user.uid,
    email: user.email,
    displayName: user.displayName,
    photoURL: user.photoURL,
    isAnonymous: false,
    phoneNumber: user.phoneNumber,
    emailVerified: user.emailVerified,
    metadata: {
      creationTime: user.metadata.creationTime,
      lastSignInTime: user.metadata.lastSignInTime,
    } as UserMetadata,
    refreshToken: user.refreshToken,
    tenantId: user.tenantId,
  } as User;
};

export const formatRoute = (route: string, params: Record<string, any>): string => {
  let formattedRoute = route;

  Object.keys(params).forEach((key) => {
    formattedRoute = formattedRoute.replace(`:${key}`, params[key]);
  });

  return formattedRoute;
};

export const formatDate = (date: Date|number, dateFormat = DateFormats.detailedDateTime) => (
  format(new Date(date), dateFormat)
);
